var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgWatermelon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.58779 8.244911A590.951062 590.951062 0 0 0 6.101524 425.290148c0 327.429494 265.441436 592.897229 592.897229 592.897229a591.003661 591.003661 0 0 0 417.097836-171.486266z",
    fill: "#BFD94F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M598.998753 1023.999579A598.512185 598.512185 0 0 1 173.44561 4.15533L177.56149 0l846.727411 846.714261-4.15533 4.076431A596.855313 596.855313 0 0 1 598.998753 1023.999579zM177.627239 16.502972c-106.907702 110.142548-165.687214 255.10571-165.687213 408.787176 0 323.708106 263.363771 587.071877 587.085027 587.071877 153.707765 0 298.644628-58.792661 408.774025-165.687214z",
    fill: "#541018"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M215.840497 50.837045A530.97492 530.97492 0 0 0 61.790837 425.500544c0 294.160553 238.45809 532.631793 532.631793 532.631793a530.922321 530.922321 0 0 0 374.650349-154.049659z",
    fill: "#FF667C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M594.42263 964.602028A539.140933 539.140933 0 0 1 211.238074 46.287222l4.576123-4.615573 4.602423 4.589273L978.251525 804.108977l-4.615572 4.602423a535.879788 535.879788 0 0 1-379.213323 155.890628zM215.893096 60.04189A522.861507 522.861507 0 0 0 68.260528 425.500544c0 290.123571 236.03853 526.162101 526.162102 526.162102a522.887806 522.887806 0 0 0 365.458654-147.632568z",
    fill: "#541018"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M811.340245 770.762267a22.893765 12.886783 68.67 1 0 24.0081-9.374851 22.893765 12.886783 68.67 1 0-24.0081 9.374851Z",
    fill: "#541018"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M717.51293 812.742829a22.893765 12.886783 82.7 1 0 25.564657-3.274908 22.893765 12.886783 82.7 1 0-25.564657 3.274908Z",
    fill: "#541018"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M610.399611 827.094791a22.893765 12.886783 90 1 0 25.773567 0 22.893765 12.886783 90 1 0-25.773567 0Z",
    fill: "#541018"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M492.537997 842.483896a12.886783 22.893765 12.19 1 0 9.668229-44.755147 12.886783 22.893765 12.19 1 0-9.668229 44.755147Z",
    fill: "#541018"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M367.808157 793.053757a12.886783 22.893765 27.71 1 0 21.291044-40.536272 12.886783 22.893765 27.71 1 0-21.291044 40.536272Z",
    fill: "#541018"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M260.818457 703.198226a12.886783 22.893765 45 1 0 32.376673-32.376673 12.886783 22.893765 45 1 0-32.376673 32.376673Z",
    fill: "#541018"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M193.69488 594.817833a12.886783 22.893765 60 1 0 39.653164-22.893765 12.886783 22.893765 60 1 0-39.653164 22.893765Z",
    fill: "#541018"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M158.65266 465.376347a12.886783 22.893765 87.12 1 0 45.729698-2.300563 12.886783 22.893765 87.12 1 0-45.729698 2.300563Z",
    fill: "#541018"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M183.514105 348.237211a22.893765 12.886783 2.9 1 0 1.30396-25.74056 22.893765 12.886783 2.9 1 0-1.30396 25.74056Z",
    fill: "#541018"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M218.681591 233.92251a22.893765 12.886783 12.19 1 0 5.442197-25.192444 22.893765 12.886783 12.19 1 0-5.442197 25.192444Z",
    fill: "#541018"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWatermelon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/watermelon.61f448ae54d9fb85ebad4e7349690fdc.svg";